// Mirrors Campaign::DEFAULT_MAXIMUM_DAYS — the model rejects a longer span
// unless the campaign is flagged as multi_month.
export const MAX_CAMPAIGN_DURATION_DAYS = 31;

export const tabs = {
  active: {
    name: 'Active',
    tooltip: 'active',
  },
  deleted: {
    name: 'Marked for deletion',
    tooltip: 'deleted',
  },
};

export const filters = {
  ACTIVE: 'unarchived',
  ARCHIVED: 'archived',
  DELETED: 'recoverable',
};

export const columns = [
  {
    title: 'Name',
    sortable: true,
    width: '443px',
    padding: '0 16px 0 24px',
    columnName: 'name',
    tooltipStyle: 'engagement-table',
  },
  {
    title: 'Start Date',
    width: '229px',
    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'left',
    columnName: 'startDate',
  },
  {
    title: 'End Date',
    width: '229px',
    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'left',
    columnName: 'endDate',
  },
  {
    title: 'Status',
    width: '140px',
    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'left',
    columnName: 'status',
  },
];

export const deletedColumns = [
  {
    title: 'Name',
    sortable: true,
    width: '443px',
    padding: '0 16px 0 24px',
    columnName: 'name',
    tooltipStyle: 'engagement-table',
  },
  {
    title: 'Start Date',
    width: '229px',
    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'left',
    columnName: 'startDate',
  },
  {
    title: 'End Date',
    width: '229px',
    padding: '0 24px 0 0',
    sortable: true,
    sortLocation: 'left',
    columnName: 'endDate',
  },
  {
    title: 'Deleted On',
    width: '229px',
    padding: '0 24px 0 0',
    sortable: true,
    columnName: 'deletedAt',
  },
];
